module.exports = require("autobind-decorator");